import { createClient } from "@supabase/supabase-js";

// Runtime-fetched config singleton.
// The Supabase client is initialised AFTER bootstrapSupabase() fetches the
// backend-supplied config (see /api/public/config). This bypasses the React
// build-time env var injection which is unreliable on some hosting platforms.

let _client = null;
let _configured = false;
let _error = null;
let _diagnostics = null;
let _bootstrapPromise = null;

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

export function getSupabase() {
  return _client;
}

export function isSupabaseConfigured() {
  return _configured;
}

export function getBootstrapError() {
  return _error;
}

export function getBootstrapDiagnostics() {
  return _diagnostics;
}

export async function bootstrapSupabase() {
  if (_bootstrapPromise) return _bootstrapPromise;
  _bootstrapPromise = (async () => {
    if (!BACKEND_URL) {
      _error = "REACT_APP_BACKEND_URL is empty in the bundle";
      _diagnostics = { reason: "no_backend_url" };
      return { configured: false, error: _error, diagnostics: _diagnostics };
    }
    try {
      const resp = await fetch(`${BACKEND_URL}/api/public/config`, {
        method: "GET",
        cache: "no-store",
        headers: { Accept: "application/json" },
      });
      if (!resp.ok) {
        _error = `Backend config endpoint returned HTTP ${resp.status}`;
        _diagnostics = { http_status: resp.status };
        return { configured: false, error: _error, diagnostics: _diagnostics };
      }
      const data = await resp.json();
      _diagnostics = data.diagnostics || null;
      if (data.configured && data.supabase_url && data.supabase_anon_key) {
        _client = createClient(data.supabase_url, data.supabase_anon_key, {
          auth: {
            persistSession: true,
            autoRefreshToken: true,
            detectSessionInUrl: true,
          },
        });
        _configured = true;
        return { configured: true, error: null, diagnostics: _diagnostics };
      }
      _error =
        "Backend returned empty SUPABASE_URL or SUPABASE_ANON_KEY. Populate these two variables in the BACKEND environment section of your hosting dashboard and redeploy.";
      return { configured: false, error: _error, diagnostics: _diagnostics };
    } catch (e) {
      _error = `Bootstrap fetch failed: ${e?.message || e}`;
      _diagnostics = { fetch_error: String(e?.message || e) };
      return { configured: false, error: _error, diagnostics: _diagnostics };
    }
  })();
  return _bootstrapPromise;
}

// Legacy named exports (live read of the singletons) for files that still
// reference them. After bootstrapSupabase() resolves, these reflect the
// current state.
export function supabaseProxy() {
  return _client;
}
